import { get } from 'lodash/fp';
import { type FinanceProductSettings } from '../../../../../api/types';
import { type FinanceProductFormValues } from '../index';

const mapDataToFormValues = (formValues: FinanceProductSettings): FinanceProductFormValues => {
    // get list variant references
    const variantReferences: string[] = get('vehicleReferenceParameters.finderVehicle.variants', formValues) || [];

    // concat data
    const variants = variantReferences.join(',');

    return {
        ...formValues,
        vehicleReferenceParameters: {
            ...formValues.vehicleReferenceParameters,
            finderVehicle: {
                ...formValues.vehicleReferenceParameters.finderVehicle,
                variants,
            },
        },
    };
};

export default mapDataToFormValues;
